import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-block',
  templateUrl: './home-block.component.html',
  styleUrls: ['./home-block.component.scss']
})
export class HomeBlockComponent implements OnInit {

  @Input() title: string;
  @Input() text: boolean;
  @Input() textContent: string;
  @Input() button: boolean;
  @Input() buttonLink: string;
  @Input() buttonName: string;
  @Input() ariaLabelValue: string;

  constructor() {
  }

  public ngOnInit() {
  }
}
